import bg1 from '../assets/images/resources/backgrounds/MOTIVO_01.jpg';
import bg2 from '../assets/images/resources/backgrounds/MOTIVO_03.jpg';
import bg3 from '../assets/images/resources/backgrounds/MOTIVO_05.jpg';
import bg4 from '../assets/images/resources/backgrounds/MOTIVO_06.jpg';
import bg5 from '../assets/images/resources/backgrounds/MOTIVO_07.jpg';
import bg6 from '../assets/images/resources/backgrounds/MOTIVO_10.jpg';
import bg7 from '../assets/images/resources/backgrounds/MOTIVO_13.jpg';
import bg8 from '../assets/images/resources/backgrounds/MOTIVO_14.jpg';
import bg9 from '../assets/images/resources/backgrounds/MOTIVO_15.jpg';
import bg10 from '../assets/images/resources/backgrounds/MOTIVO_16.jpg';

import texture1 from '../assets/images/resources/textures/TEXTURA_01.png';
import texture2 from '../assets/images/resources/textures/TEXTURA_02.png';
import texture3 from '../assets/images/resources/textures/TEXTURA_03.png';
import texture4 from '../assets/images/resources/textures/TEXTURA_04.png';
import texture5 from '../assets/images/resources/textures/TEXTURA_05.png';
import texture6 from '../assets/images/resources/textures/TEXTURA_06.png';
import texture7 from '../assets/images/resources/textures/TEXTURA_07.png';
import texture8 from '../assets/images/resources/textures/TEXTURA_08.png';

import date1 from '../assets/images/resources/letters/dates/FECHAS_01.png';
import date2 from '../assets/images/resources/letters/dates/FECHAS_03.png';
import date3 from '../assets/images/resources/letters/dates/FECHAS_06.png';
import date4 from '../assets/images/resources/letters/dates/FECHAS_07.png';
import date5 from '../assets/images/resources/letters/dates/FECHAS_08.png';
import date6 from '../assets/images/resources/letters/dates/FECHAS_09.png';
import date7 from '../assets/images/resources/letters/dates/FECHAS_10.png';
import date8 from '../assets/images/resources/letters/dates/FECHAS_12.png';
import date9 from '../assets/images/resources/letters/dates/FECHAS_15.png';
import date10 from '../assets/images/resources/letters/dates/FECHAS_16.png';

import detail1 from '../assets/images/resources/letters/details/ELEMENTOS_01.png';
import detail2 from '../assets/images/resources/letters/details/ELEMENTOS_04.png';
import detail3 from '../assets/images/resources/letters/details/ELEMENTOS_06.png';
import detail4 from '../assets/images/resources/letters/details/ELEMENTOS_10.png';
import detail5 from '../assets/images/resources/letters/details/ELEMENTOS_15.png';
import detail6 from '../assets/images/resources/letters/details/SELLOS_03.png';
import detail7 from '../assets/images/resources/letters/details/SELLOS_05.png';
import detail8 from '../assets/images/resources/letters/details/SELLOS_06.png';
import detail9 from '../assets/images/resources/letters/details/SELLOS_11.png';
import detail10 from '../assets/images/resources/letters/details/SELLOS_12.png';

import phra1 from '../assets/images/resources/letters/phrases/FRASES_04.png';
import phra2 from '../assets/images/resources/letters/phrases/FRASES_08.png';
import phra3 from '../assets/images/resources/letters/phrases/FRASES_12.png';
import phra4 from '../assets/images/resources/letters/phrases/FRASES_13.png';
import phra5 from '../assets/images/resources/letters/phrases/FRASES_14.png';
import phra6 from '../assets/images/resources/letters/phrases/SALUDOS_05.png';
import phra7 from '../assets/images/resources/letters/phrases/SALUDOS_06.png';
import phra8 from '../assets/images/resources/letters/phrases/SALUDOS_09.png';
import phra9 from '../assets/images/resources/letters/phrases/SALUDOS_10.png';
import phra10 from '../assets/images/resources/letters/phrases/SALUDOS_11.png';

import iconFondos from '../assets/images/icons/icon_fondos.svg';
import iconFondosSelected from '../assets/images/icons/icon_fondos_selected.svg';
import iconTexturas from '../assets/images/icons/icon_texturas.svg';
import iconTexturasSelected from '../assets/images/icons/icon_texturas_selected.svg';
import iconFrases from '../assets/images/icons/icon_frases.svg';
import iconFrasesSelected from '../assets/images/icons/icon_frases_selected.svg';
import iconDetalles from '../assets/images/icons/icon_detalles.svg';
import iconDetallesSelected from '../assets/images/icons/icon_detalles_selected.svg';
import iconFechas from '../assets/images/icons/icon_fechas.svg';
import iconFechasSelected from '../assets/images/icons/icon_fechas_selected.svg';
import { CSSProperties } from 'react';

interface Resources {
  style: CSSProperties;
  images: string[];
}

interface GalleryCategories {
  [key: string]: any;
  fondos: Resources;
  texturas: Resources;
  detalles: Resources;
  fechas: Resources;
  frases: Resources;
}

export const CARTA_SETTINGS: SelectedCategorySettings<GalleryCategories> = {
  title: '03 • Carta',
  gallery: {
    fondos: {
      style: {
        objectFit: 'cover',
        objectPosition: 'top',
      },
      images: [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10],
    },
    texturas: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#8d8d8d',
      },
      images: [texture1, texture2, texture3, texture4, texture5, texture6, texture7, texture8],
    },
    fechas: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [date1, date2, date3, date4, date5, date6, date7, date8, date9, date10],
    },
    detalles: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [
        detail1,
        detail2,
        detail3,
        detail4,
        detail5,
        detail6,
        detail7,
        detail8,
        detail9,
        detail10,
      ],
    },
    frases: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [phra1, phra2, phra3, phra4, phra5, phra6, phra7, phra8, phra9, phra10],
    },
  },
  toolsSelection: [
    {
      key: 'fondos',
      name: 'Fondos',
      icon: iconFondos,
      selectedIcon: iconFondosSelected,
    },
    {
      key: 'texturas',
      name: 'Texturas',
      icon: iconTexturas,
      selectedIcon: iconTexturasSelected,
    },
    {
      key: 'frases',
      name: 'Frases',
      icon: iconFrases,
      selectedIcon: iconFrasesSelected,
    },
    {
      key: 'detalles',
      name: 'Detalles',
      icon: iconDetalles,
      selectedIcon: iconDetallesSelected,
    },
    {
      key: 'fechas',
      name: 'Fechas',
      icon: iconFechas,
      selectedIcon: iconFechasSelected,
    },
  ],
};
